import type { Locale, TranslationTree } from "@llmgateway/i18n";

export const authPageMessages = {
	en: {
		authMeta: {
			forgotPassword: {
				title: "Forgot Password",
				description:
					"Reset your doteb password. We'll email you a secure link to set a new one.",
			},
			login: {
				title: "Log In",
				description:
					"Log in to your doteb account to manage API keys, monitor usage, and access 210+ AI models through one unified API.",
			},
			resetPassword: {
				title: "Reset Password",
				description: "Set a new password for your doteb account.",
			},
			signup: {
				title: "Sign Up",
				description:
					"Create your free doteb account. Get instant access to 210+ AI models from OpenAI, Anthropic, Google, and more through one API key.",
			},
		},
		authBrand: {
			apiCallsRouted: "API calls routed",
			everyLlm: "every LLM.",
			llmProviders: "LLM providers",
			loginSubtitle:
				"Pick up where you left off. Your AI infrastructure is running smoothly.",
			loginTitle: "Welcome back.",
			oneApiFor: "One API for",
			privateDeploymentNote:
				"Built for private deployments, centralized model access, and usage controls your team can operate from one dashboard.",
			signupSubtitle:
				"Route requests across providers, cut costs with smart caching, and ship AI features without vendor lock-in.",
			trustedBy: "Trusted by developers building AI-powered applications",
			uptimeSla: "Uptime SLA",
		},
		socialAuth: {
			failedSignIn: "Failed to sign in with {provider}",
		},
	},
	"zh-CN": {
		authMeta: {
			forgotPassword: {
				title: "忘记密码",
				description:
					"重置你的 doteb 密码。我们会通过邮件发送安全链接，用于设置新密码。",
			},
			login: {
				title: "登录",
				description:
					"登录 doteb 账号，管理 API 密钥、监控用量，并通过统一 API 访问 210+ AI 模型。",
			},
			resetPassword: {
				title: "重置密码",
				description: "为你的 doteb 账号设置新密码。",
			},
			signup: {
				title: "注册",
				description:
					"创建免费的 doteb 账号。通过一个 API 密钥即时访问 OpenAI、Anthropic、Google 等供应商的 210+ AI 模型。",
			},
		},
		authBrand: {
			apiCallsRouted: "API 调用已路由",
			everyLlm: "连接所有 LLM。",
			llmProviders: "LLM 供应商",
			loginSubtitle: "继续上次的工作。你的 AI 基础设施正在稳定运行。",
			loginTitle: "欢迎回来。",
			oneApiFor: "一个 API",
			privateDeploymentNote:
				"面向私有化部署、集中模型访问和用量管控，团队可在一个 dashboard 中完成日常运营。",
			signupSubtitle:
				"跨供应商路由请求，用智能缓存降低成本，在不被供应商锁定的情况下交付 AI 功能。",
			trustedBy: "受到构建 AI 应用的开发者信赖",
			uptimeSla: "可用性 SLA",
		},
		socialAuth: {
			failedSignIn: "使用 {provider} 登录失败",
		},
	},
} satisfies Partial<Record<Locale, TranslationTree>>;
